var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookWithUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    height: 112,
    width: 168,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDCAE0"
    },
    d: "M671.688,370.72c-26.012,39.457-70.61,62.65-117.87,62.65H161.567 c-78.842,0-123.053-92.183-71.922-144.09c51.132-51.907,5.968-96.24,84.836-137.865c76.407-40.326,102.493,45.632,172.882-10.612 c70.389-56.244,172.866-50.938,195.381,6.367c22.515,57.305,17.209,77.472,64.963,90.205 c47.754,12.732,94.447,84.894,65.795,130.526C672.905,368.852,672.3,369.792,671.688,370.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCF4"
    },
    d: "M654.251,386.715c-41.323,3.505-69.178,80.962-172.478,34.405c0,0,11.343-33.814,62.155-54.89 C594.74,345.154,654.251,386.715,654.251,386.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BDD1"
    },
    d: "M495.879,415.32c10.784-5.607,21.971-10.441,33.395-14.646c2.843-1.092,5.725-2.074,8.616-3.031 c2.878-0.998,5.794-1.88,8.705-2.781c2.901-0.935,5.854-1.695,8.797-2.492c1.473-0.392,2.94-0.808,4.419-1.179l4.449-1.068 l4.46-1.023l4.492-0.884l4.491-0.882c1.498-0.286,3.01-0.51,4.519-0.739c3.021-0.445,6.03-0.952,9.073-1.243 c3.038-0.315,6.06-0.753,9.118-0.867c12.169-0.884,24.474-0.683,36.473,1.347c-12.154-0.294-24.205,0.425-36.157,1.898 l-2.242,0.255l-2.233,0.343l-4.467,0.652c-2.984,0.383-5.938,0.981-8.9,1.516c-1.477,0.29-2.967,0.497-4.441,0.804l-4.422,0.918 l-4.421,0.919l-4.394,1.053l-4.404,1.007c-1.465,0.35-2.919,0.747-4.379,1.118l-4.377,1.132c-1.461,0.37-2.9,0.823-4.358,1.205 c-2.908,0.798-5.822,1.578-8.704,2.474c-2.887,0.879-5.792,1.701-8.668,2.624C518.783,407.344,507.349,411.3,495.879,415.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M659.308,254.901c-50.42,36.041-27.095,156.822-195.354,175.839c0,0-11.232-52.103,37.97-117.963 C551.126,246.918,659.308,254.901,659.308,254.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCF4"
    },
    d: "M475.148,416.189c7.339-15.9,16.396-31.02,26.587-45.333 c10.161-14.343,21.553-27.84,33.962-40.339c12.423-12.477,25.884-23.982,40.452-33.915c14.522-9.928,30.19-18.471,46.899-23.795 c-15.509,8.133-29.881,17.799-43.53,28.4c-13.6,10.661-26.458,22.223-38.641,34.468c-12.191,12.241-23.679,25.181-34.614,38.618 C495.361,387.767,485.116,401.79,475.148,416.189z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCF4"
    },
    d: "M115.408,375.95c40.974,6.406,63.305,85.632,169.627,46.465c0,0-8.934-34.529-58.135-59.131 C177.698,338.683,115.408,375.95,115.408,375.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0BDD1"
    },
    d: "M271.373,415.637c-11.159-4.818-22.285-9.569-33.539-13.967c-2.804-1.123-5.644-2.148-8.462-3.228 c-2.811-1.097-5.664-2.08-8.508-3.081c-1.428-0.484-2.831-1.037-4.263-1.509l-4.286-1.437c-1.43-0.473-2.853-0.971-4.289-1.424 l-4.322-1.315l-4.309-1.359l-4.345-1.228l-4.346-1.228c-1.449-0.409-2.921-0.721-4.374-1.115 c-2.916-0.742-5.821-1.547-8.771-2.139l-4.41-0.965l-2.203-0.499l-2.218-0.412c-11.819-2.312-23.79-3.877-35.934-4.44 c12.112-1.18,24.401-0.514,36.477,1.225c3.042,0.329,6.025,0.978,9.034,1.507c3.015,0.505,5.981,1.223,8.963,1.879 c1.489,0.335,2.981,0.664,4.456,1.056l4.418,1.196l4.418,1.198l4.377,1.334l4.363,1.379c1.449,0.474,2.883,0.993,4.325,1.487 c2.879,1.003,5.771,1.969,8.6,3.106c2.841,1.104,5.687,2.189,8.488,3.387c2.817,1.158,5.622,2.341,8.381,3.63 C250.192,403.674,261.011,409.284,271.373,415.637z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M142.646,249.353c45.402,37.554,15.197,150.534,173.49,179.833c0,0,14.14-48.659-28.111-114.41 C245.773,249.025,142.646,249.353,142.646,249.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCF4"
    },
    d: "M306.493,414.638c-8.556-14.29-17.364-28.249-26.818-41.737 c-9.491-13.454-19.523-26.481-30.26-38.899c-10.728-12.422-22.134-24.248-34.292-35.284 c-12.212-10.982-25.16-21.137-39.289-29.955c15.524,6.1,29.844,15.225,42.974,25.598c13.175,10.378,25.185,22.189,36.137,34.86 c10.936,12.691,20.833,26.267,29.488,40.57C293.12,384.065,300.665,399.035,306.493,414.638z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6A397"
    },
    d: "M409.65,354.532c-5.684,6.749-10.835,17.939-14.032,19.716c-3.197,1.776-8.588,2.394-13.682,18.79 c-5.094,16.397,20.625,14.152,20.625,14.152s10.997-6.316,15.438-21.575l11.012-9.769L409.65,354.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M389.755,405.392c0,0,8.324-2.711,15.385-10.168c7.087-7.486,8.001-20.804,8.001-20.804 l3.395,6.343l6.79-7.257l3.273-0.317l2.413,2.656l-11.012,9.769c-4.44,15.259-15.438,21.575-15.438,21.575 s-7.09,0.615-13.088-1.171C389.628,405.631,389.755,405.392,389.755,405.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5470D3"
    },
    d: "M448.208,295.802c-7.878,5.759-12.578,9.938-16.495,17.772 c-3.917,7.834-28.464,35.98-30.031,38.49c-1.567,2.51,13.795,29.146,26.092,35.675c0,0,18.564-21.414,29.27-29.509 c10.707-8.095,7.051-36.821,2.089-46.483C454.171,302.084,448.208,295.802,448.208,295.802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M447.921,347.633v-15.989c0,0,2.084-0.835,3.71,4.562c0.65,2.159,0.599,4.429,0.31,6.383 l11.952-8.989c0.494,10.063-1.121,20.298-6.849,24.629c-10.707,8.095-29.27,29.509-29.27,29.509 c-3.172-1.684-6.547-4.711-9.784-8.313C425.547,371.9,439.888,357.371,447.921,347.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6A397"
    },
    d: "M371.553,400.874c-2.044,0.638-3.554,1.615-3.554,4.19c0,2.575,0.444,6.661,1.421,8.259 c0.977,1.599,6.022,2.556,6.022,2.556s-0.338-10.638-1.403-12.592C372.972,401.334,371.553,400.874,371.553,400.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M369.419,413.324c-0.275-0.449-0.503-1.107-0.695-1.861c1.095,1.076,1.462,1.084,2.802,1.226 l3.83,1.194c0.059,1.197,0.084,1.997,0.084,1.997S370.396,414.922,369.419,413.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6A397"
    },
    d: "M376.435,396.983c-2.487,0.266-4.973,2.131-4.973,4.707s-0.888,9.769,0,10.924 c0.888,1.155,5.24,4.441,6.75,4.707c1.51,0.266,4.074-0.178,3.724-0.977C381.586,415.544,376.435,396.983,376.435,396.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M371.085,410.68c1.886,2.128,6.707,1.937,6.707,1.937s2.119,2.263,2.38,2.99 c0.158,0.439,1.025,1.017,1.144,1.464c-0.798,0.304-2.158,0.416-3.104,0.249c-1.48-0.261-5.683-3.42-6.685-4.632l-0.442-2.004 C371.085,410.683,371.085,410.682,371.085,410.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6A397"
    },
    d: "M385.753,392.734c-7.63,0.43-9.051,1.14-9.317,4.249c-0.266,3.108-0.089,12.167,0.888,14.476 c0.977,2.309,1.51,4.352,2.753,5.595c1.243,1.243,3.103,1.248,3.103,1.248s4.179-6.132,4.357-11.283 C387.714,401.867,385.753,392.734,385.753,392.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M381.364,413.199c0.387-2.11,1.245-4.358,1.354-11.417c0.041-2.652,2.5,11.198,1.402,14.998 c-0.547,0.943-0.94,1.521-0.94,1.521s-1.86-0.004-3.103-1.248c-1.243-1.243-1.776-3.286-2.753-5.595 c-0.064-0.15-0.123-0.331-0.18-0.535C377.641,412.219,379.223,413.069,381.364,413.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6A397"
    },
    d: "M402.457,408.35c-0.48,4.244-6.039,5.773-6.661,7.904c-0.622,2.131-0.178,4.085-1.243,4.618 c-1.066,0.533-5.506-1.954-5.329-4.796c0,0-1.155,2.398-3.73,2.842c-2.576,0.444-3.197-1.437-2.753-4.271 c0.444-2.834,0.355-4.344,0.266-7.718c-0.089-3.375-0.888-6.483,0.622-10.213c1.51-3.73,3.552-7.016,7.638-6.394 c4.085,0.622,6.572,5.773,8.792,7.549C402.279,399.647,402.99,403.643,402.457,408.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M389.224,416.077c0.249-5.397,0.531-9.814,0.531-10.685c0-0.871-0.282-6.599,1.755-6.947 c0.309-0.053,4.788,2.785,4.875,4.701c0.087,1.915,0,5.353-1.393,6.333C393.598,410.458,389.224,416.077,389.224,416.077z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5470D3"
    },
    d: "M574.296,307.307c-8.095-10.272-10.881-11.316-19.237-16.191 c-8.357-4.875-40.042-17.235-46.57-18.802c-6.529-1.567-32.859,10.707-41.499,14.624c-8.64,3.917-19.633,7.771-21.507,11.589 c-6.27,12.779,6.148,30.89,6.214,68.842c0.034,19.878,4.564,64.577,4.564,64.577s99.495,0.186,100.888-1.903 c1.393-2.089,4.875-73.468,6.615-88.092C565.504,327.328,574.296,307.307,574.296,307.307z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M445.848,318.536c-0.746-2.403-1.189-4.849-1.561-7.306c-0.341-2.461-0.609-4.933-0.572-7.449 c0.748,2.402,1.191,4.849,1.561,7.306C445.615,313.548,445.882,316.02,445.848,318.536z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M483.054,303.585c-3.844-1.436-12.952,1.061-14.617,1.641c-1.665,0.579,0.979-6.537,1.958-7.418 c0.979-0.881,2.546-2.933,5.549-2.005c3.003,0.928,5.527,4.366,5.963,5.498C482.343,302.432,483.054,303.585,483.054,303.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M515.084,309.526c-1.371-0.065-9.368-3.743-11.284-4.657s-10.59-1.341-16.415,0.287 c0,0,11.214-7.577,17.743-7.512c6.529,0.065,9.009,2.416,9.532,4.505C515.182,304.238,515.084,309.526,515.084,309.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M472.313,415.942c1.068-1.045,66.045,1.045,67.351-5.745c1.306-6.79,2.204-19.138,2.204-19.138 c-7.822,4.178-19.179,2.439-19.179,2.439c7.573-2.473,18.541-14.899,19.063-18.555c1.609-11.263-4.408-42.314-4.408-42.314 l4.408-8.87l5.158-2.873c0,0,9.78,4.871,18.144,13.831c-0.565,2.479-1.016,4.925-1.291,7.235 c-1.641,13.788-4.83,78.012-6.357,87.067c-20.125,0.742-56.608,2.078-81.02,2.916c-11.828,0.028-20.127,0.013-20.127,0.013 s-0.153-5.879-0.508-14.311C462.562,417.237,471.65,416.589,472.313,415.942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5470D3"
    },
    d: "M485.508,305.479c7.011-0.845,18.28-6.92,22.719-4.831c4.439,2.089,5.484,7.442,6.398,8.356 s4.831-3.656,4.831-14.885c0-11.229,0.345-22.727-7.923-24.29c-8.268-1.563-29.681,6.533-33.99,9.797 c-4.309,3.264-6.137,6.57-7.312,9.749c-1.175,3.178-4.309,15.974-2.873,16.105c1.436,0.13,5.484-8.226,8.487-8.487 C478.849,296.73,483.609,305.708,485.508,305.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M481.519,295.425c-1.788-4.243-3.746-7.965-3.681-10.903c0.065-2.938,0.718-4.962,3.982-5.876 c3.264-0.914,4.635,0.849,4.831,5.288C486.848,288.374,481.519,295.425,481.519,295.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M507.115,287.514c6.825-6.191,7.598-13.111,6.957-14.547c-0.641-1.436-3.46-2.481-3.46-2.481 s-1.11,4.505-0.457,5.615C510.808,277.21,507.115,287.514,507.115,287.514z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M496.251,302.48c1.663-0.747,3.398-1.33,5.168-1.81c1.778-0.433,3.605-0.777,5.502-0.654 c0.936,0.071,1.942,0.274,2.779,0.937c0.738,0.697,1.301,1.327,1.928,2.043c1.244,1.412,2.1,3.126,2.888,4.738 c0.175,0.371,0.449,0.808,0.57,0.847c0.014,0.005,0.008,0.028,0.149-0.06c0.118-0.083,0.255-0.225,0.381-0.381 c0.508-0.651,0.925-1.464,1.333-2.256c0.821-1.563,1.263-3.295,1.612-5.059c0.341-1.765,0.536-3.567,0.663-5.374 c0.156-1.807,0.207-3.623,0.232-5.444c0.359,3.626,0.365,7.298-0.137,10.945c-0.244,1.818-0.7,3.656-1.521,5.35 c-0.406,0.831-0.817,1.652-1.417,2.446c-0.159,0.197-0.33,0.395-0.582,0.578c-0.121,0.091-0.287,0.177-0.485,0.225 c-0.206,0.049-0.455,0.016-0.641-0.072c-0.374-0.188-0.532-0.438-0.683-0.651c-0.145-0.22-0.258-0.433-0.366-0.643 c-0.79-1.654-1.573-3.234-2.722-4.583c-0.55-0.669-1.194-1.406-1.761-1.974c-0.592-0.493-1.439-0.738-2.295-0.846 c-1.737-0.206-3.554,0.036-5.319,0.367C499.744,301.461,497.992,301.945,496.251,302.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M480.175,300.138c-0.756-0.67-1.509-1.339-2.33-1.894c-0.405-0.279-0.82-0.545-1.248-0.728 c-0.215-0.082-0.424-0.146-0.619-0.172c-0.086,0.009-0.178,0.001-0.246,0.023c-0.063,0.043-0.102,0.026-0.225,0.117 c-1.683,1.038-2.994,2.464-4.107,4.097c-0.565,0.788-1.06,1.689-1.728,2.507c-0.333,0.405-0.688,0.797-1.138,1.146 c-0.235,0.164-0.473,0.353-0.895,0.403c-0.202,0.033-0.483-0.053-0.654-0.205c-0.171-0.155-0.258-0.333-0.306-0.485 c-0.184-0.618-0.125-1.133-0.077-1.656c0.065-0.516,0.156-1.02,0.272-1.516c0.25-0.988,0.526-1.96,0.881-2.909 c-0.135,1.003-0.315,1.993-0.398,2.99c-0.056,0.495-0.094,0.991-0.101,1.478c-0.002,0.474,0.007,0.994,0.151,1.333 c0.03,0.086,0.079,0.131,0.096,0.143c0.024-0.002,0,0.008,0.049-0.007c0.084-0.008,0.282-0.121,0.44-0.258 c0.334-0.284,0.647-0.654,0.933-1.04c0.588-0.759,1.061-1.634,1.652-2.493c0.594-0.838,1.244-1.651,1.999-2.375 c0.754-0.721,1.627-1.341,2.528-1.818c0.083-0.058,0.293-0.134,0.465-0.182c0.172-0.034,0.341-0.015,0.502-0.005 c0.304,0.061,0.567,0.17,0.81,0.298c0.473,0.269,0.879,0.593,1.266,0.933C478.894,298.569,479.583,299.314,480.175,300.138z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6A397"
    },
    d: "M480.561,269.919c0.016,2.759,0.125,5.51,0.412,8.255c0.704,6.733,0.014,15.612,0.546,17.251 c0.594,1.828,4.119,8.357,4.119,8.357s6.267-2.873,8.879-6.006s6.006-3.292,10.576-7.913c4.57-4.621,7.677-11.961,6.659-18.07 c-0.13-0.783-0.933-8.604-1.11-16.7c-0.177-8.095-8.683-14.246-16.778-14.246c-8.095,0-12.941,12.012-13.195,20.108 C480.565,264.276,480.547,267.395,480.561,269.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M510.643,255.092c0.177,8.095,0.979,15.916,1.11,16.7c0.315,1.889,0.233,3.895-0.162,5.902 c-1.791,0.331-24.847,0.887-30.82-1.894c-0.136-1.956-0.199-3.916-0.21-5.88c-0.014-2.524,0.004-5.643,0.109-8.965 c0.108-3.432,1.043-7.565,2.699-11.191l18.966-6.722C506.989,245.525,510.529,249.904,510.643,255.092z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#504984"
    },
    d: "M466.359,221.383c-12.25,0-16.834,9.409-16.834,16.462c0,6.329,2.029,16.462,16.834,16.462 c7.403,0,12.414-7.37,12.414-16.462C478.773,228.754,473.762,221.383,466.359,221.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372D5B"
    },
    d: "M465.818,225.415c-9.25,0-12.712,7.105-12.712,12.43c0,4.779,1.532,12.431,12.712,12.431 c5.59,0,9.374-5.565,9.374-12.431C475.192,230.98,471.408,225.415,465.818,225.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6A397"
    },
    d: "M450.904,226.94c0.724,4.292,2.848,5.933,3.797,11.719c0.949,5.786-1.582,14.195,2.192,21.518 c3.775,7.323,9.878,16.952,13.404,17.359c3.526,0.407,31.767-4.363,41.295-23.312c2.735-5.439,8.581-26.768,3.578-39.791 c-5.002-13.023-13.139-24.957-31.945-25.319C464.42,188.752,447.069,204.192,450.904,226.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M466.632,250.401c1.005,0.023,2.108-0.36,2.603-1.019c0.434-0.577,0.615-1.337,0.487-2.047 c-1.47,1.212-3.272,1.42-5.082,1.104C464.416,249.79,465.457,250.374,466.632,250.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA6454"
    },
    d: "M499.9,226.94c-0.716-4.465-3.7-7.041-3.7-7.041s-7.188-2.984-12.748-3.526 c-5.56-0.543-11.256-2.17-11.256-2.17s1.763,4.465,4.747,6.368c0,0-13.29-0.673-17.495-4.605c0,0,0.814,3.241,1.627,5.418 c0,0-6.51-0.671-8.544-3.248c0,0-1.627,5.674-1.627,8.804c0,0-7.821-10.703-5.831-19.202c1.989-8.499,4.701-11.753,4.701-11.753 s-5.605,0.542-8.679,0c0,0,7.233-6.329,12.658-10.488c5.425-4.159,21.699-4.34,21.699-4.34s-1.266-4.34,0.181-11.211 c0,0,6.962,10.216,14.33,13.336s6.376,2.855,14.189,4.826c7.813,1.972,15.24,6.973,18.359,11.177 c3.119,4.204,6.51,8.544,8.544,9.222c0,0-4.882-0.678-7.323-2.712c0,0,4.071,9.245-1.31,21.145 c-5.38,11.9-18.86,8.379-21.474,5.752C498.333,230.065,499.9,226.94,499.9,226.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#874438"
    },
    d: "M500.946,232.692c-2.614-2.627-1.047-5.752-1.047-5.752c-0.433-2.701-1.694-4.705-2.625-5.872 c1.956-11.86,1.158-24.168-2.315-35.675c2.03,0.825,3.235,1.195,6.174,1.95c3.608,5.427,6.306,11.533,8.164,17.718 c2.366,7.876,3.511,16.385,1.304,24.307c-0.566,2.031-1.391,4.012-2.434,5.867C504.823,234.955,502.001,233.751,500.946,232.692z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#504984"
    },
    d: "M504.628,222.52c0,0,0.93-29.745-14.666-39.238c0,0,12.07-1.356,18.986,10.714 c6.916,12.07,6.448,22.422,6.274,28.224C515.048,228.021,504.628,222.52,504.628,222.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#504984"
    },
    d: "M509.383,221.383c12.25,0,16.834,9.409,16.834,16.462c0,6.329-2.029,16.462-16.834,16.462 c-7.403,0-12.414-7.37-12.414-16.462C496.968,228.754,501.98,221.383,509.383,221.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372D5B"
    },
    d: "M502.779,237.845c0-8.071,5.328-14.614,11.9-14.614c6.572,0,11.538,6.543,11.538,14.614 c0,8.071-4.966,14.614-11.538,14.614C508.106,252.459,502.779,245.916,502.779,237.845z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#504984"
    },
    cx: 516.249,
    cy: 237.845,
    rx: 8.098,
    ry: 9.945
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M478.333,254.307c-3.31,1.823-14.123,2.43-14.859,2.329c-0.736-0.101,0.775,8.109,3.423,8.413 c2.648,0.304,7.944-0.405,10.151-2.531C479.255,260.39,478.333,254.307,478.333,254.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M477.641,256.701c-0.204-0.728-0.363-1.313-0.517-1.882c-3.642,1.243-10.811,1.769-13.021,1.822 c0.18,1.098,0.496,2.209,0.944,3.301c0.07-0.045-0.017,0.105,0.053,0.06C469.872,260.753,474.727,259.206,477.641,256.701z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F1751"
    },
    d: "M476.874,234.681c0-1.498,0.739-2.712,1.65-2.712c0.911,0,1.65,1.214,1.65,2.712 c0,1.498-0.739,2.712-1.65,2.712C477.613,237.393,476.874,236.179,476.874,234.681z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F1751"
    },
    d: "M457.994,235.946c0-1.498,0.635-2.712,1.419-2.712c0.783,0,1.418,1.214,1.418,2.712 s-0.635,2.712-1.418,2.712C458.629,238.659,457.994,237.444,457.994,235.946z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F1751"
    },
    d: "M486.112,224.107c-1.127-0.62-2.341-1.049-3.587-1.407c-1.251-0.336-2.548-0.534-3.866-0.58 c-1.309-0.066-2.694-0.102-3.962,0.387c-1.271,0.438-2.424,1.237-3.273,2.29l0.096,0.161c1.362-0.147,2.487-0.481,3.675-0.638 c1.161-0.174,2.288-0.599,3.502-0.697c2.401-0.204,4.917-0.014,7.338,0.655L486.112,224.107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F1751"
    },
    d: "M453.222,227.612c0.588-0.228,1.207-0.371,1.824-0.443c0.614-0.083,1.229-0.113,1.837-0.12 c0.614-0.008,1.222,0.211,1.82,0.064c0.302-0.068,0.609-0.126,0.924-0.257c0.316-0.108,0.639-0.248,0.986-0.491l0.02-0.187 c-0.59-0.576-1.258-0.822-1.936-0.945c-0.685-0.129-1.363,0.146-2.021,0.326c-0.662,0.173-1.31,0.404-1.919,0.715 c-0.599,0.332-1.185,0.679-1.651,1.189L453.222,227.612z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#504984"
    },
    d: "M472.313,422.377c0.008,0.42-0.58,1.028-2.016,1.028c-1.436,0-40.063,0-45.286,0 c-5.223,0-6.441-2.066-4.875-4.677c1.567-2.611,8.182-8.357,24.547-12.361c16.365-4.004,24.97,5.358,27.63,9.575 C474.264,419.034,472.313,422.377,472.313,422.377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372D5B"
    },
    d: "M419.75,419.511c0.901,2.996,35.456,1.433,35.456,1.433s-3.503-4.733-7.377-4.868 c-3.874-0.135-5.758,1.211-10.952,2.105c-5.195,0.894-1.343-2.114-1.343-2.114s-3.67-0.813-5.164-1.971 c0,0,8.559-2.529,12.15-3.117c3.591-0.588,12.731-0.196,13.906,0c0.831,0.139,5.048-2.311,10.146-1.081 c2.845,2.078,4.728,4.434,5.742,6.043c1.951,3.092,0,6.435,0,6.435c0.008,0.42-0.58,1.028-2.016,1.028 c-1.436,0-40.063,0-45.286,0C420.324,423.404,418.869,421.739,419.75,419.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6A397"
    },
    d: "M567.55,394.063c0,0-32.205,4.98-49.661,8.104c-16.536,2.959-30.815,4.243-34.862,3.46 c-4.048-0.783-17.888-5.876-22.328-7.704s-13.318-2.872-17.888-1.436c-4.57,1.436-8.313,3.003-10.141,3.003 s-1.48,2.96,0.957,3.569c2.437,0.609,4.614,0.522,4.614,0.522s-8.269,4.526-9.749,4.962s0.273,3.134,2.276,2.96 c0,0-1.753,1.045-1.144,2.089c0.609,1.045,4.962,1.045,4.962,1.045s-5.31,2.611-0.871,3.656 c4.439,1.044,9.749-3.917,11.926-4.352c2.176-0.435,7.225-0.174,9.662,1.654c2.437,1.828,12.883,10.272,27.159,5.223 c0,0,96.896,3.926,106.558,3.926c9.662,0,15.498-8.54,12.4-24.992c-3.098-16.452-9.104-28.726-9.104-28.726l-33.426,2.35 L567.55,394.063z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M445.87,400.966c0.853-0.201,1.533-0.318,1.959-0.344 C447.829,400.621,447.002,400.764,445.87,400.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M438.241,403.581c0,0-2.176,0.087-4.614-0.522c-0.685-0.171-1.199-0.531-1.552-0.956 c2.711,1.198,6.047,0.433,7.874-0.002c1.153-0.275,3.985-0.791,5.92-1.136C443.932,401.421,441.091,402.312,438.241,403.581z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M438.667,407.498c0.209-0.095,0.386-0.17,0.5-0.205 C439.168,407.294,438.98,407.371,438.667,407.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M428.509,410.482c0.031,0.028,0.987,0.87,2.999-0.005c1.676-0.729,5.743-2.398,7.16-2.978 c-1.782,0.809-6.614,3.536-7.9,4.004C429.878,411.58,429.039,411.089,428.509,410.482z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M433.51,413.678c1.48-0.435,4.57-2.307,6.463-3.202c1.893-0.895,4.309-0.999,4.309-0.999 s-0.718,0.065-2.612,0.999c-1.893,0.933-7.085,4.159-7.085,4.159s-2.793-0.001-4.216-0.539 C430.384,414.097,432.036,414.112,433.51,413.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M461.06,415.811c2.742,1.698,10.837,3.917,15.668,3.003c4.831-0.914,5.876-4.962,5.876-4.962 l1.349,4.352c0,0,67.2,1.915,80.867,1.301c13.51-0.607,34.581-0.914,37.333-9.029c-0.755,9.418-5.857,14.266-13.133,14.266 c-9.662,0-106.558-3.926-106.558-3.926c-14.276,5.049-24.721-3.395-27.159-5.223c-2.026-1.52-5.852-1.954-8.337-1.808 c0,0,0,0,0,0C450.673,412.486,458.318,414.114,461.06,415.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D65863"
    },
    d: "M567.55,394.063c0,0,12.59-1.711,15.115-1.972l-1.915-7.834l-15.93,3.221L567.55,394.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5470D3"
    },
    d: "M601.198,372.133c0.474,1.226,0.173,2.605-0.767,3.524c-5.852,5.714-13.533,13.496-21.434,14.693 c-8.618,1.306-22.981,1.828-23.764,0s-3.656-25.07-8.879-36.821c-5.223-11.751-8.618-17.758-9.923-24.547 c-1.306-6.79,10.446-22.719,15.668-24.025c5.223-1.306,17.235-2.089,22.197,2.35c4.962,4.439,8.618,21.414,14.363,34.21 C593.295,351.841,599.121,366.758,601.198,372.133z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M568.875,304.729c-1.599-0.184-3.198-0.317-4.799-0.353c-1.599-0.065-3.198-0.059-4.788,0.035 c-1.59,0.097-3.173,0.255-4.732,0.536c-0.783,0.125-1.551,0.307-2.322,0.479c-0.717,0.261-1.455,0.452-2.116,0.864 c-0.702,0.315-1.312,0.811-1.957,1.241c-0.586,0.517-1.213,0.987-1.749,1.567c-1.148,1.079-2.115,2.345-3.095,3.594 c-0.955,1.273-1.824,2.615-2.649,3.986c-0.849,1.359-1.605,2.774-2.339,4.207c1.079-3.039,2.572-5.927,4.36-8.637 c0.91-1.345,1.898-2.649,3.052-3.818c0.542-0.616,1.207-1.119,1.819-1.669c0.685-0.47,1.327-1.001,2.095-1.357 c0.719-0.435,1.549-0.655,2.346-0.927c0.8-0.168,1.595-0.36,2.404-0.464c1.613-0.231,3.237-0.384,4.86-0.369 C562.505,303.639,565.745,303.953,568.875,304.729z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#314EC6"
    },
    d: "M594.678,376.944c-0.043-4.172-8.854-42.425-16.637-63.745l0,0 c3.309,7.285,6.401,18.924,10.618,28.317c4.636,10.325,10.462,25.242,12.539,30.617c0.474,1.226,0.174,2.605-0.767,3.524 c-2.241,2.189-4.753,4.679-7.441,6.988C593.193,382.448,594.718,380.84,594.678,376.944z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA5E5B"
    },
    d: "M174.624,333.85c-0.159,1.287,0.11,2.584,0.735,3.721c2.279,4.145,3.434,8.906,3.285,13.635 c-0.098,3.116-0.738,6.303,0.11,9.303c1.463,5.175,6.925,8.375,8.683,13.458c1.558,4.506,0.109,10.173,3.348,13.672 c0.803,0.867,2.049,1.531,3.146,1.092c0.551-0.221,0.964-0.681,1.356-1.126c3.713-4.217,7.688-9.342,6.543-14.842 c-1.076-5.167-6.401-8.659-7.411-13.84c-0.825-4.233,1.339-9.117-1.086-12.683c-0.669-0.984-1.627-1.737-2.358-2.675 c-2.884-3.704-1.816-9.607-5.139-12.922c-1.084-1.081-2.44-1.694-3.918-2.01C178.433,327.886,175.062,330.314,174.624,333.85 L174.624,333.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA6A4"
    },
    d: "M195.74,399.508c0.223-2.757,0.318-5.514,0.421-8.279c-0.126-2.756-0.273-5.513-0.509-8.267 c-0.236-2.754-0.546-5.509-1.033-8.247c-0.495-2.721-1.149-5.5-2.294-8.059c-1.999-5.056-3.616-10.342-5.249-15.581 l-2.368-7.898c-0.973-2.58-1.923-5.165-2.841-7.769c0.402,2.74,1.029,5.429,1.579,8.138l2.374,7.916 c1.643,5.265,3.244,10.519,5.293,15.701c1.108,2.477,1.721,5.099,2.212,7.782c0.477,2.68,0.783,5.401,1.017,8.129 c0.229,2.729,0.39,5.468,0.495,8.211L195.74,399.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA6A4"
    },
    d: "M181.188,343.64c0.454,0.688,1.04,1.204,1.669,1.66c0.323,0.217,0.702,0.358,1.054,0.536 c0.357,0.171,0.669,0.401,0.959,0.663l0.126,0.114l0.112-0.171c0.263-0.402,0.583-0.775,0.834-1.183 c0.243-0.412,0.498-0.817,0.714-1.242c0.42-0.856,0.733-1.765,0.892-2.751l-0.078-0.039c-0.689,0.723-1.224,1.521-1.652,2.374 c-0.208,0.429-0.377,0.878-0.558,1.32c-0.172,0.447-0.276,0.927-0.438,1.38l0.237-0.057c-0.335-0.199-0.648-0.429-0.916-0.72 c-0.273-0.283-0.519-0.603-0.821-0.847c-0.621-0.466-1.285-0.872-2.081-1.105L181.188,343.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA6A4"
    },
    d: "M181.858,353.063c0.474,0.39,0.962,0.812,1.473,1.164c0.511,0.362,1.03,0.71,1.591,0.991 c0.567,0.272,1.169,0.487,1.714,0.796c0.548,0.303,1.048,0.685,1.537,1.082l0.172,0.14l0.174-0.228 c0.756-0.99,1.402-2.042,2.012-3.115c0.574-1.093,1.086-2.221,1.453-3.431l-0.076-0.043c-0.847,0.939-1.549,1.959-2.189,3.015 c-0.604,1.076-1.172,2.173-1.63,3.331l0.346-0.088c-0.572-0.267-1.135-0.547-1.651-0.904c-0.519-0.351-0.983-0.793-1.483-1.175 c-0.506-0.374-1.058-0.675-1.621-0.957c-0.571-0.273-1.137-0.539-1.804-0.665L181.858,353.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA6A4"
    },
    d: "M185.206,365.5c0.519,0.523,1.098,0.908,1.695,1.256c0.589,0.363,1.236,0.604,1.926,0.767 c0.687,0.167,1.31,0.47,1.864,0.894c0.553,0.42,1.094,0.883,1.648,1.245l0.418,0.274l0.311-0.466 c0.458-0.686,0.874-1.396,1.197-2.156c0.324-0.76,0.612-1.54,0.772-2.39l-0.096-0.053c-0.632,0.591-1.137,1.251-1.605,1.932 c-0.469,0.68-0.846,1.411-1.18,2.166l0.729-0.192c-0.632-0.349-1.304-0.549-1.969-0.782c-0.664-0.228-1.271-0.557-1.818-1.013 c-0.544-0.462-1.139-0.826-1.794-1.066c-0.648-0.252-1.319-0.456-2.053-0.517L185.206,365.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E67471"
    },
    d: "M200.124,400.047c2.154-0.354,10.231-2.938,9.667-5.047c-2.421-9.052-4.842-19.321,3.542-23.749 c4.035-2.13,9.099-3.213,11.396-7.155c2.366-4.06,0.624-9.221-1.499-13.413c-2.123-4.192-4.68-8.68-3.77-13.29 c0.953-4.828,5.518-8.391,6.249-13.257c0.997-6.645-5.455-11.999-11.654-14.593c-2.108-0.882-4.426-1.636-6.648-1.1 c-1.587,0.383-2.963,1.4-4.051,2.617c-4.354,4.868-4.176,12.214-3.183,18.67s2.514,13.273,0.083,19.336 c-1.727,4.306-5.424,8.356-4.434,12.888c0.397,1.815,1.529,3.399,1.96,5.206c1.164,4.873-2.884,9.262-4.739,13.915 c-2.394,6.004-0.751,13.341,3.787,17.896C197.694,399.837,198.917,400.246,200.124,400.047L200.124,400.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA6A4"
    },
    d: "M199.362,400.147c0.499-3.583,0.998-7.154,1.637-10.698c0.152-0.887,0.338-1.768,0.48-2.654 c0.135-0.887,0.214-1.782,0.361-2.667c0.268-1.774,0.566-3.542,0.904-5.3c0.684-3.511,1.502-7.007,2.702-10.332 c0.602-1.655,1.316-3.275,2.259-4.672c0.468-0.696,1.021-1.313,1.633-1.729c0.807-0.53,1.577-1.213,2.179-2.026 c1.242-1.646,1.617-3.737,1.572-5.622c-0.042-1.91-0.403-3.733-0.807-5.514c-0.83-3.555-1.875-6.989-2.456-10.486 c-0.59-3.479-0.705-7.043,0.214-10.38c0.283-0.815,0.505-1.643,0.773-2.473c0.274-0.826,0.629-1.629,1.03-2.414 c0.805-1.572,1.854-3.035,3.016-4.426c-1.425,1.118-2.746,2.409-3.849,3.903c-0.554,0.743-1.072,1.526-1.513,2.356 c-0.456,0.822-0.842,1.696-1.042,2.619c-1.005,3.653-0.862,7.477-0.25,11.086c0.605,3.628,1.668,7.114,2.475,10.582 c0.395,1.732,0.73,3.472,0.765,5.174c0.036,1.695-0.292,3.35-1.25,4.616c-0.474,0.636-1.068,1.174-1.767,1.634 c-0.883,0.602-1.537,1.372-2.077,2.166c-1.077,1.598-1.817,3.312-2.45,5.04c-1.25,3.466-2.077,7.02-2.772,10.585 c-0.344,1.784-0.645,3.574-0.916,5.367c-0.124,0.898-0.291,1.79-0.4,2.69c-0.092,0.902-0.132,1.81-0.189,2.715 C199.43,392.91,199.295,396.529,199.362,400.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA6A4"
    },
    d: "M213.669,329.493c-0.62,0.216-1.14,0.578-1.622,0.963c-0.477,0.393-0.933,0.808-1.269,1.334 c-0.34,0.522-0.643,1.074-1.079,1.501c-0.419,0.445-0.925,0.806-1.411,1.196l0.639,0.04c-0.215-0.464-0.481-0.898-0.725-1.343 c-0.251-0.441-0.503-0.88-0.801-1.288c-0.279-0.419-0.599-0.815-0.903-1.217c-0.306-0.403-0.652-0.775-0.929-1.203l-0.108,0.018 c-0.024,0.564,0.147,1.088,0.319,1.582c0.189,0.491,0.4,0.968,0.655,1.418c0.238,0.46,0.539,0.878,0.845,1.293 c0.314,0.409,0.615,0.824,0.976,1.202l0.4,0.42l0.239-0.38c0.327-0.519,0.642-1.058,1.05-1.509 c0.391-0.468,0.922-0.804,1.424-1.163c0.505-0.356,0.904-0.81,1.294-1.272c0.388-0.468,0.749-0.951,1.074-1.505L213.669,329.493 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA6A4"
    },
    d: "M205.839,343.199c0.256,0.616,0.591,1.178,0.964,1.706c0.381,0.521,0.778,1.029,1.234,1.481 c0.466,0.444,1,0.822,1.5,1.231c0.49,0.418,0.922,0.888,1.314,1.401l0.125,0.163l0.176-0.141 c0.652-0.519,1.17-0.993,1.684-1.545c0.487-0.556,1.005-1.083,1.458-1.661c0.457-0.575,0.883-1.172,1.288-1.786 c0.409-0.611,0.776-1.251,1.202-1.848l-0.062-0.091c-0.715,0.338-1.272,0.861-1.824,1.36c-0.544,0.513-1.048,1.057-1.515,1.628 c-0.472,0.567-0.873,1.19-1.311,1.78c-0.428,0.577-0.789,1.294-1.195,1.801l0.301,0.023c-0.496-0.407-0.943-0.865-1.327-1.379 c-0.375-0.524-0.711-1.081-1.105-1.583c-0.404-0.493-0.864-0.934-1.321-1.378c-0.466-0.437-0.96-0.847-1.501-1.231 L205.839,343.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA6A4"
    },
    d: "M220.241,353.779c-0.68,0.799-1.385,1.534-2.106,2.236c-0.723,0.705-1.5,1.32-2.255,1.997 c-0.771,0.655-1.644,1.241-2.633,1.529c-0.981,0.309-2.022,0.348-3.026,0.337l0.449,0.316c-0.177-0.846-0.44-1.643-0.717-2.449 c-0.272-0.805-0.62-1.587-1.041-2.334c-0.416-0.749-0.91-1.463-1.492-2.108c-0.592-0.629-1.278-1.219-2.097-1.512l-0.055,0.095 c0.62,0.562,1.098,1.21,1.513,1.902c0.422,0.686,0.78,1.411,1.131,2.141l1.008,2.225c0.331,0.745,0.623,1.522,0.913,2.276 l0.14,0.365l0.309-0.048c1.069-0.167,2.083-0.529,3.074-0.878c0.979-0.382,1.986-0.718,2.949-1.21 c0.973-0.476,1.793-1.215,2.48-2.037c0.686-0.824,1.246-1.761,1.552-2.793L220.241,353.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA6A4"
    },
    d: "M200.764,361.876c-0.33,0.793-0.443,1.657-0.421,2.513c0.036,0.854,0.171,1.716,0.47,2.522 c0.315,0.8,0.776,1.535,1.293,2.201l1.507,2.003l0.107,0.143l0.174-0.124c0.815-0.579,1.743-1.019,2.628-1.48 c0.883-0.475,1.798-0.879,2.714-1.269c0.915-0.394,1.828-0.794,2.768-1.146c0.932-0.382,1.891-0.687,2.864-1.053l-0.016-0.108 c-2.077-0.045-4.175,0.396-6.085,1.237c-0.958,0.418-1.859,0.954-2.731,1.521c-0.869,0.58-1.644,1.278-2.403,1.998l0.281,0.019 c-0.558-0.588-1.067-1.238-1.391-1.986c-0.362-0.729-0.54-1.523-0.788-2.266c-0.482-1.5-0.788-3.044-0.863-4.697 L200.764,361.876z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#504984"
    },
    d: "M185.48,423.404h23.056c2.14,0,3.959-1.85,4.281-4.354l3.65-28.362 c0.399-3.103-1.63-5.898-4.281-5.898h-30.356c-2.652,0-4.681,2.795-4.281,5.898l3.65,28.362 C181.521,421.554,183.34,423.404,185.48,423.404z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372D5B"
    },
    d: "M181.831,384.791h15.519c-2.652,0-4.681,2.795-4.281,5.898l3.65,28.362 c0.322,2.504,2.141,4.354,4.281,4.354H185.48c-2.14,0-3.959-1.85-4.281-4.354l-3.65-28.362 C177.15,387.586,179.179,384.791,181.831,384.791z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#282142"
    },
    d: "M392.011,415.616h-96.43c-0.971,0-1.758,0.787-1.758,1.758v4.272c0,0.971,0.787,1.758,1.758,1.758 h96.43V415.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#504984"
    },
    d: "M416.828,420.988v1.737c0,0.375-0.304,0.679-0.679,0.679h-24.291 c-0.756,0-1.369-0.613-1.369-1.368v-5.06c0-0.817,0.711-1.452,1.522-1.36l24.213,4.698 C416.568,420.352,416.828,420.643,416.828,420.988z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#504984"
    },
    d: "M223.491,251.719h180.226c3.646,0,6.901,2.287,8.136,5.718l39.415,109.458 c1.648,5.645-2.482,9.875-9.119,10.59c-1.017,0.11-5.858-2.066-13.461-5.642H267.565c-3.646,0-6.901-2.287-8.136-5.718 l-35.606-98.879c-6.02-3.142-9.452-4.938-9.452-4.938S212.143,251.719,223.491,251.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372D5B"
    },
    d: "M398.074,257.361H217.849c-2.56,0-4.344,2.539-3.477,4.948l39.415,109.458 c1.235,3.431,4.49,5.718,8.136,5.718h180.226c2.56,0,4.344-2.539,3.477-4.948L406.21,263.079 C404.975,259.648,401.721,257.361,398.074,257.361z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#282142"
    },
    points: "357.387,377.485 349.387,347.813 319.066,377.485  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#504984"
    },
    d: "M313.507,295.802c0.793,4.894,3.959,6.866,7.751,6.866c3.792,0,6.645-3.133,5.981-6.866 c-0.664-3.732-3.959-6.866-7.751-6.866S312.9,292.059,313.507,295.802z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#282142"
    },
    points: "398.207,359.271 395.889,352.835 398.802,352.835 401.12,359.271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#282142"
    },
    points: "392.072,359.271 389.755,352.835 392.668,352.835 394.986,359.271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#282142"
    },
    points: "385.938,359.271 383.62,352.835 386.533,352.835 388.851,359.271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#282142"
    },
    points: "379.803,359.271 377.486,352.835 380.399,352.835 382.717,359.271  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#282142"
    },
    points: "292.668,359.271 290.351,352.835 293.264,352.835 295.581,359.271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#282142"
    },
    points: "286.534,359.271 284.216,352.835 287.129,352.835 289.447,359.271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#282142"
    },
    points: "280.399,359.271 278.082,352.835 280.995,352.835 283.312,359.271  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#282142"
    },
    points: "274.265,359.271 271.947,352.835 274.86,352.835 277.178,359.271  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372D5B"
    },
    d: "M296.529,412.826c1.779-5.114,23.345-74.705,23.345-74.705h27.684l1.829,9.692 c0,0-18.562,59.899-20.34,65.013c-0.135,0.39-0.265,0.781-0.386,1.172l0.002,0c-1.627,5,2.665,4.979,7.498,4.979 c4.834,0,48.823,0,48.823,0v4.427h-48.823h-32.518C293.861,423.404,294.75,417.94,296.529,412.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#504984"
    },
    d: "M347.558,338.121c0,0-21.567,69.591-23.345,74.705c-1.779,5.114-2.668,10.578,7.115,10.578 H298.81c-9.783,0-8.893-5.464-7.115-10.578c1.779-5.114,23.345-74.705,23.345-74.705H347.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F74D1"
    },
    d: "M340.778,338.121c-2.145-0.099-4.29-0.148-6.435-0.218c-2.145-0.074-4.29-0.09-6.434-0.137 c-2.145-0.034-4.29-0.097-6.435-0.097l-6.435-0.04l-0.359-0.002l-0.112,0.348c-0.897,2.803-1.781,5.609-2.624,8.429 l-2.566,8.447c-1.651,5.65-3.304,11.298-4.814,16.992c1.982-5.547,3.819-11.139,5.659-16.73l2.671-8.414 c0.903-2.801,1.764-5.615,2.613-8.432l-0.47,0.346l6.435-0.04c2.145-0.001,4.29-0.063,6.435-0.097 c2.145-0.048,4.29-0.064,6.434-0.137C336.489,338.27,338.633,338.22,340.778,338.121z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E5058"
    },
    d: "M152.177,440.489h477.344c4.718,0,8.542-3.824,8.542-8.542l0,0c0-4.718-3.825-8.542-8.542-8.542 H152.177c-4.718,0-8.542,3.825-8.542,8.542l0,0C143.635,436.664,147.459,440.489,152.177,440.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64364A"
    },
    d: "M152.177,440.489h477.344c4.718,0,8.542-3.824,8.542-8.542l0,0H143.635l0,0 C143.635,436.664,147.459,440.489,152.177,440.489z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2_",
    transform: "matrix(0.2279 -0.9737 0.9737 0.2279 -9.1089 294.5681)",
    style: {
      fill: "#5470D3"
    },
    cx: 181.188,
    cy: 153.028,
    rx: 71.85,
    ry: 71.85
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M253.038,153.028c0,39.682-32.169,71.85-71.85,71.85c-39.682,0-71.85-32.169-71.85-71.85 c0-39.682,32.169-85.802,71.85-85.802C220.87,67.225,253.038,113.346,253.038,153.028z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016035862346822899150000008551094394740036243_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016035862346822899150000008551094394740036243_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5C7"
    },
    d: "M282.218,210.367c1.365,6.857-4.982,12.95-6.969,14.093 c-1.987,1.142-15.324,6.474-23.336,6.665c-8.011,0.19-18.584-16.757-14.257-18.661c4.328-1.904,33.806-3.999,37.043-3.999 C277.936,208.464,282.218,210.367,282.218,210.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.208,206.75c-3.496,20.566-11.801,36.561-14.393,36.847 c-2.591,0.286-27.487-8.284-34.351-11.425c-6.863-3.142,2.108-51.409,6.379-50.559c4.271,0.85,13.636,10.123,21.369,14.569 C247.946,200.628,261.208,206.75,261.208,206.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCEDFF"
    },
    d: "M220.202,215.299c2.4,4.116,22.184,14.548,33.08,18.351c-2.693,6.073-5.23,9.81-6.466,9.946 c-2.219,0.245-20.788-6.002-30.388-9.776C217.232,226.179,220.202,215.299,220.202,215.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5C7"
    },
    d: "M282.247,209.416c0.196,8.159-7.153,9.331-15.951,7.236 c-8.797-2.095-23.161-21.899-29.556-30.848c-6.394-8.95-18.325-24.898-20.792-26.326c-2.467-1.428-8.125-2.186-12.966-10.233 c-4.841-8.047,1.527-24.9,3.815-26.899c2.288-2,21.892,4.676,24.169,8.051c2.277,3.374-1.613,21.512-0.923,23.797 c0.691,2.285,17.375,20.946,24.66,25.516C261.987,184.28,282.105,203.513,282.247,209.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M216.837,135.809c-2.306-1.143-2.863-6.332-1.413-5.417c1.451,0.914,3.988,0.895,7.42,0.847 c3.433-0.048,4.84-0.344,4.84-0.344s0.352,2.248,0.334,4.09C228.019,134.986,219.143,136.952,216.837,135.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M201.571,136.989c1.398-2.599,2.477-4.57,2.477-4.57l13.486,12.981 c3.688-3.198,8.199-6.116,8.199-6.116l1.187,2.116c-2.182,3.692-4.083,11.499-4.126,13.403c0,0-2.071,2.285-3.227,2.476 c0,0,14.428,22.851,23.703,34.086c9.22,11.169,15.535,20.829,19.882,23.934c-8.77-5.056-20.732-21.545-26.413-29.496 c-6.394-8.95-18.325-24.898-20.792-26.326c-2.467-1.428-8.125-2.186-12.966-10.233 C201.061,146.052,200.918,141.476,201.571,136.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0C0835"
    },
    d: "M229.641,138.293c-0.163,1.331-13.565,12.949-14.968,14.282c-0.105,0.1-1.152,0.253-1.441,0 c-3.564-3.132-19.127-31.392-19.405-32.412c-0.259-0.951,10.072-10.673,13.227-13.273c0.43-0.354,2.2-0.14,2.491,0.29 C212.729,111.894,229.853,136.572,229.641,138.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252384"
    },
    d: "M228.201,138.293c-0.163,1.331-13.565,12.949-14.968,14.282 c-1.402,1.333-20.545-31.31-20.845-32.412c-0.26-0.951,11.243-10.515,14.398-13.116c0.429-0.354,1.029-0.298,1.319,0.132 C211.289,111.894,228.412,136.572,228.201,138.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57AFF7"
    },
    d: "M225.945,136.383c-0.153,1.245-12.69,12.114-14.002,13.361 c-1.312,1.247-19.22-29.291-19.501-30.322c-0.243-0.89,10.518-9.837,13.469-12.27c0.402-0.331,0.963-0.279,1.235,0.124 C210.123,111.686,226.143,134.773,225.945,136.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5C7"
    },
    d: "M217.907,120.454c-2.075-1.251-4.623-5.488-4.852-6.916c-0.229-1.428-0.088-2.714,1.027-2.999 c1.116-0.286,4.551,4.189,6.263,5.522c1.712,1.333,3.796,4.094,2.947,5.951c-0.849,1.857-4.653,1.142-5.061,0.857 C217.824,122.583,217.907,120.454,217.907,120.454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M213.44,110.914c-0.658,1.623,3.629,8.14,7.388,10.015l-1.398,1.598 c0,0-0.634-0.14-1.449-0.333c-0.111-0.723-0.075-1.74-0.075-1.74c-2.075-1.251-4.623-5.488-4.852-6.916 C212.881,112.455,212.925,111.46,213.44,110.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5C7"
    },
    d: "M222.733,127.037c-3.571-1.908-6.371-1.694-8.314-2.479c-1.942-0.785-2.295-3.785-0.974-4.285 c1.322-0.5,9.369,0.786,11.444,1.714c2.074,0.928,3.066,5.205,3.066,5.205L222.733,127.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M221.169,124.812c2.019,0.381,2.714,0,2.714,0c-0.057,0.789,0.687,1.182,1.526,2.304 l-2.676-0.079c-3.571-1.908-6.371-1.694-8.313-2.479c-0.886-0.358-1.424-1.178-1.64-2.01 C213.644,124.193,219.159,124.433,221.169,124.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5C7"
    },
    d: "M230.965,130.396c-1.906,2.637-11.248,1.494-13.132,1.208 c-1.883-0.286-3.066-1.475-2.873-2.675c0.388-2.419,12.734-1.991,13.754-1.61 C229.734,127.701,230.965,130.396,230.965,130.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M215.028,129.512c1.276,1.269,4.345,1.992,7.694,2.262c2.899,0.234,4.567,0.122,4.952,0.088 c-3.521,0.561-8.518-0.058-9.841-0.258C216.261,131.366,215.23,130.491,215.028,129.512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M187.241,167.332c19.831,10.092,23.085,9.702,31.603,14.28 c8.518,4.578,5.983,52.749,5.443,60.176c-0.54,7.426-2.593,36.942-1.461,44.94c1.132,7.998,5.54,37.704,7.492,42.274 c1.952,4.57,5.676,12.282-0.084,16.852c-5.76,4.57-17.946,7.712-44.405,5.998c-26.459-1.714-54.98-17.995-56.242-20.28 c-1.262-2.285,12.648-44.273,13.23-52.271c0.582-7.998,2.161-13.996,3.003-17.709c0.842-3.713-7.575-21.137-8.92-32.277 c-1.345-11.14-13.448-41.87-11.153-47.499c2.295-5.629,23.375-11.901,37.729-19.059 C177.83,155.598,187.241,167.332,187.241,167.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCEDFF"
    },
    d: "M206.903,179.823c-3.265,10.73-9.912,20.405-18.758,27.301 c-10.74-2.635-21.66-7.367-30.455-14.07c9.828,7.239,20.547,13.328,32.023,17.486 C199.406,202.601,205.158,192.229,206.903,179.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5C7"
    },
    d: "M202.854,174.715c-3.809-1.625-8.703-3.867-15.613-7.383c0,0-9.411-11.734-23.766-4.576 c-4.981,2.484-10.77,4.861-16.304,7.141c8.551,14.548,22.406,25.928,38.398,31.34 C194.003,194.596,200.067,185.08,202.854,174.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCEDFF"
    },
    d: "M129.587,331.572c-1.262-2.285,12.648-44.273,13.23-52.271 c0.582-7.997,2.161-13.996,3.003-17.709c0.842-3.713-7.575-21.137-8.92-32.277c-0.234-1.936-0.797-4.471-1.548-7.356 l8.942-6.66c5.244,14.627,8.515,40.334,13.485,46.618c4.97,6.284,17.351,8.855,17.351,8.855s-12.229,2.856-17.561,1.714 c0,0-5.693,22.565-5.758,33.705c-0.064,11.14,0.97,27.992,1.101,30.277c0.049,0.853-0.139,3.827-0.394,7.218 C139.703,338.613,130.3,332.862,129.587,331.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5C7"
    },
    d: "M165.728,142.464c-0.204,11.919-0.991,20.107-3.633,22.393c0,0,4.542,19.779,22.677,18.09 c6.135-0.571,5.55-10.854,2.469-15.615l1.826-14.62L165.728,142.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M163.476,162.757L163.476,162.757c1.552-3.656,2.089-10.78,2.252-20.293l23.339,10.249 l-1.171,9.375l0,0C183.759,163.944,163.476,162.757,163.476,162.757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5C7"
    },
    d: "M101.457,238.864c-4.02,5.522-9.397,19.233-7.379,25.517 c2.018,6.284,22.832,34.276,32.352,44.749s11.681,12.187,13.336,15.615c1.655,3.428,9.766,17.567,11.895,19.709 c2.129,2.142,5.964,2.428,5.964,2.428s2.867,3.142,8.359,2.571c0,0,4.783,3.285,8.577,4.142c0,0,1.252,2.425,2.521,2.641 c1.27,0.216,2.885-2.355,0.546-7.497c-2.339-5.141-6.182-7.284-6.8-10.568c-0.618-3.285-3.591-9.986-3.591-9.986 s6.675,6.844,10.786,7.272s4.663-1.999,2.407-3.999c-2.256-1.999-5.18-4.999-7.898-8.855 c-2.719-3.856-6.102-6.427-11.334-7.141c-5.232-0.714-8.904-1.285-10.259-2.285c-1.355-1-8.197-10.711-12.872-21.185 c-4.676-10.473-8.863-23.857-20.746-35.609l5.235-9.14L101.457,238.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M174.385,352.939c-1.014-2.896-2.875-5.367-4.924-7.565l-0.811-0.799 c-0.24-0.249-0.664-0.563-0.756-0.71c-0.41-0.522-0.764-1.21-1.158-1.83c-0.754-1.284-1.487-2.593-2.321-3.854 c0.397,1.482,0.931,2.899,1.529,4.295c0.294,0.711,0.614,1.37,1.062,2.073c0.347,0.46,0.571,0.555,0.837,0.855l0.765,0.789 c1.028,1.054,2.003,2.162,2.985,3.267C172.566,350.574,173.478,351.733,174.385,352.939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M165.761,348.464c-0.787-1.538-1.721-2.871-2.554-4.273c-0.872-1.383-1.646-2.77-2.439-4.296 c-0.086,1.798,0.576,3.49,1.452,4.944C163.133,346.284,164.298,347.554,165.761,348.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M161.581,349.073c-2.591-0.748-3.956-2.192-3.956-2.192s-3.835-0.286-5.964-2.428 c-0.87-0.876-2.742-3.762-4.761-7.095c0.044,0.053,2.437,2.653,4.157,4.799c2.423,3.022,5.901,2.022,5.901,2.022l-0.466-2.785 C156.492,341.395,158.805,347.716,161.581,349.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M93.989,257.399c0.113,2.606,0.144,4.678,4.01,11.516c4.351,7.697,30.499,40.132,36.203,46.13 c5.704,5.997,5.535,6.38,8.911,15.857c-1.524-2.678-2.796-5.015-3.347-6.157c-1.655-3.428-3.815-5.141-13.336-15.615 s-30.334-38.465-32.352-44.749C93.491,262.555,93.542,260.095,93.989,257.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M114.484,249.902l-2.124,3.54c0,0,2.874,0.777,4.959,2.94l4.145-7.034L114.484,249.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M139.543,230.54c5.461-10.736,7.647-28.17,2.718-37.346 c-4.929-9.176-14.232-12.479-16.514-11.378c-2.283,1.101-8.463,15.416-14.266,22.022c-5.803,6.607-21.65,25.142-22.13,26.702 c-0.48,1.56,11.454,14.151,33.9,23.399C125.923,255.04,139.543,230.54,139.543,230.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCEDFF"
    },
    d: "M122.894,238.864l-3.581,7.343c0,0,17.64-17.684,24.964-30.88 c-0.888,5.505-2.539,10.9-4.733,15.213c0,0-13.62,24.5-16.293,23.399c-3.841-1.582-7.349-3.265-10.565-4.971L122.894,238.864z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372D5B"
    },
    d: "M190.416,143.533c-1.213-4.914-1.187-9.939-1.48-14.964c-0.219-3.757-0.41-7.196-3.82-9.443 c-2.492-1.642-5.617-1.965-8.549-1.593c-7.88,1-9.575,8.679-8.972,15.949c0.462,5.565,2.636,10.909,4.794,16.028 c-2.898-0.128-6.855-1.647-8.585-4.059c0.777,3.174,2.249,6.09,4.551,8.335c-8.399-0.145-16.193-5.64-20.642-13.02 c-4.448-7.38-5.858-16.39-5.384-25.077c0.562-10.308,3.776-20.64,10.152-28.577c12.824-15.963,37.53-17.824,52.575-4.106 c5.172,4.716,8.924,11.037,10.8,17.893c2.467,9.012,2.416,18.682,0.494,27.798c-0.796,3.775-1.16,7.042-1.535,10.822 c-0.116,1.172-1.537,14.778-0.715,14.729c-5.305,0.322-11.399-0.749-14.993-4.804c1.611,2.785,3.002,5.468,4.612,8.253 C197.02,156.582,192.097,150.34,190.416,143.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC5C7"
    },
    d: "M162.887,124.99c-2.37-1.401-5.219-2.161-7.417,0.068c-3.238,3.285,1.362,18.566,8.345,14.853 c0,0,10.111,14.139,17.532,18.138c7.421,3.999,12.708,2,15.487-0.857c2.779-2.856,12.256-14.573,13.961-26.992 c0.608-4.427-0.044-13.139,0.091-14.996c0.416-5.712,2.58-10.402-1.926-14.886c-4.552-4.529-10.857-7.269-17.275-7.496 c-8.083-0.285-16.163,3.347-21.516,9.411C164.256,108.934,163.231,116.499,162.887,124.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M156.618,129.235c0.604-2.8,2.992-3.351,4.768-1.4c1.821,2,2.127,8.333,1.659,9.266 c-0.468,0.933-3.596,0.867-4.189-1.066c-0.593-1.933,1.229-3.145,2.987-2.572c0,0,0.491-2.822-0.946-4.639 c-1.437-1.817-2.935-1.122-3.302-0.655C157.228,128.635,156.618,129.235,156.618,129.235z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F1751"
    },
    d: "M175.946,116.85c0.676-0.63,1.393-1.214,2.145-1.769c0.757-0.546,1.565-1.036,2.423-1.437 c0.851-0.4,1.742-0.832,2.685-0.904c0.934-0.083,1.873-0.007,2.727,0.36l-0.012,0.128c-0.457,0.183-0.892,0.3-1.32,0.424 l-1.259,0.349c-0.819,0.241-1.668,0.314-2.498,0.59c-0.825,0.275-1.639,0.626-2.441,1.03 c-0.808,0.394-1.589,0.862-2.378,1.329L175.946,116.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F1751"
    },
    d: "M207.536,113.644c-0.765-0.405-1.575-0.701-2.417-0.878c-0.837-0.188-1.694-0.283-2.554-0.304 c-0.865-0.018-1.724,0.159-2.578,0.152c-0.861,0.003-1.726,0.029-2.671-0.066l-0.027-0.123 c0.809-0.587,1.73-0.904,2.66-1.085c0.937-0.189,1.875-0.034,2.779,0.101c0.91,0.133,1.795,0.367,2.626,0.713 c0.824,0.356,1.608,0.798,2.261,1.383L207.536,113.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F1751"
    },
    d: "M184.427,121.871c-0.032-1.208-0.64-2.13-1.359-2.06c-0.719,0.071-1.276,1.107-1.244,2.316 c0.032,1.208,0.64,2.13,1.359,2.06C183.902,124.116,184.458,123.079,184.427,121.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F1751"
    },
    d: "M203.505,120.346c-0.032-1.208-0.534-2.141-1.121-2.083c-0.588,0.057-1.038,1.084-1.007,2.292 c0.032,1.208,0.534,2.141,1.121,2.083C203.086,122.58,203.536,121.554,203.505,120.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE8A8B"
    },
    d: "M190.401,133.614c1.654,1.15,4.092,1.125,5.892-0.06c-0.205,0.931-0.621,1.838-1.527,2.169 c-0.905,0.331-1.906,0.234-2.738-0.148C191.196,135.192,190.927,134.355,190.401,133.614z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C31F2A"
    },
    d: "M183.781,140.702c3.985,0.064,13.563-0.671,16.686-1.115 c-1.231,4.036-4.461,8.023-8.97,8.025C187.436,147.615,184.754,144.278,183.781,140.702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB8384"
    },
    d: "M187.436,146.294c1.585-0.489,3.197-0.238,3.845-0.037c0,0,2.107-1.475,5.169-0.505 c-1.393,1.124-3.051,1.86-4.954,1.861C189.929,147.613,188.574,147.11,187.436,146.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M197.764,142.963c-4.033,1.257-8.435,0.895-12.234-0.474 c-0.025-0.596-0.071-1.197-0.117-1.797c3.938-0.084,10.312-0.561,13.725-0.941 C198.844,140.867,198.401,141.958,197.764,142.963z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#372D5B"
    },
    d: "M166.872,111.844c6.498-0.277,12.945-1.708,18.95-4.207c1.143-2.643,1.182-4.989,1.353-7.863 c1.633,2.996,2.604,6.349,2.771,9.757c3.784-0.245,7.587-0.449,11.371-0.694c1.06-2.999,1.188-6.087,1.02-9.263 c1.279,2.984,1.921,6.74,2.358,9.957c2.284-0.813,5.179,0.372,7.565,0.8c2.957-6.588,2.764-18.523-3.492-23.519 c-6.093-4.866-16.676-6.191-24.121-5.113c-15.84,2.293-28.288,15.445-27.305,31.829c0.561,9.347,5.25,18.186,11.974,24.703 C165.318,130.255,164.524,120.451,166.872,111.844z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2515 -0.9678 0.9678 0.2515 90.0239 432.0168)",
    style: {
      fill: "#E67471"
    },
    cx: 324.336,
    cy: 157.803,
    rx: 41.783,
    ry: 41.783
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M303.723,174.159h41.226c1.892,0,3.426-1.534,3.426-3.426v-25.86c0-1.892-1.534-3.426-3.426-3.426 h-41.226c-1.892,0-3.426,1.534-3.426,3.426v25.861C300.297,172.625,301.831,174.159,303.723,174.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDDCF4"
    },
    d: "M303.723,174.159h41.226c1.892,0,3.426-1.534,3.426-3.426l-24.039-15.117l-24.039,15.117 C300.297,172.625,301.831,174.159,303.723,174.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5470D3"
    },
    d: "M303.723,141.446h41.226c1.892,0,3.426,1.534,3.426,3.426l-24.039,15.117l-24.039-15.117 C300.297,142.98,301.831,141.446,303.723,141.446z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9742 -0.2257 0.2257 0.9742 -33.1747 145.6905)",
    style: {
      fill: "#E67471"
    },
    cx: 620.561,
    cy: 217.928,
    rx: 41.783,
    ry: 41.783
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M632.28,209.757h-4.201c-0.38-1.657-1.034-3.206-1.911-4.604l2.973-2.973 c0.405-0.406,0.405-1.063,0-1.468l-3.304-3.304c-0.406-0.405-1.063-0.405-1.468,0l-2.973,2.973 c-1.398-0.877-2.947-1.531-4.604-1.911v-4.201c0-0.573-0.465-1.038-1.038-1.038h-4.672c-0.573,0-1.038,0.465-1.038,1.038v4.201 c-1.657,0.38-3.206,1.034-4.604,1.911l-2.973-2.973c-0.406-0.405-1.063-0.405-1.468,0l-3.304,3.304 c-0.406,0.405-0.406,1.063,0,1.468l2.973,2.973c-0.877,1.398-1.531,2.947-1.911,4.604h-4.201c-0.573,0-1.038,0.465-1.038,1.038 v4.672c0,0.573,0.465,1.038,1.038,1.038h4.201c0.38,1.657,1.034,3.206,1.911,4.604l-2.973,2.973 c-0.406,0.406-0.406,1.063,0,1.468l3.304,3.304c0.406,0.406,1.063,0.406,1.468,0l2.973-2.973 c1.398,0.877,2.947,1.531,4.604,1.911v4.201c0,0.573,0.465,1.038,1.038,1.038h4.672c0.574,0,1.038-0.465,1.038-1.038v-4.201 c1.657-0.38,3.206-1.034,4.604-1.911l2.973,2.973c0.406,0.406,1.063,0.406,1.468,0l3.304-3.304c0.405-0.406,0.405-1.063,0-1.468 l-2.973-2.973c0.877-1.398,1.531-2.947,1.911-4.604h4.201c0.573,0,1.038-0.465,1.038-1.038v-4.672 C633.318,210.222,632.853,209.757,632.28,209.757z M613.417,219.579c-3.56,0-6.447-2.886-6.447-6.447 c0-3.56,2.886-6.447,6.447-6.447c3.56,0,6.447,2.886,6.447,6.447C619.864,216.692,616.978,219.579,613.417,219.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5470D3"
    },
    d: "M613.417,204.158c-4.956,0-8.974,4.018-8.974,8.974c0,4.956,4.018,8.974,8.974,8.974 c4.956,0,8.974-4.018,8.974-8.974C622.391,208.176,618.373,204.158,613.417,204.158z M613.417,218.612 c-3.026,0-5.48-2.453-5.48-5.48s2.453-5.48,5.48-5.48c3.026,0,5.48,2.453,5.48,5.48S616.444,218.612,613.417,218.612z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M650.222,228.16h-2.146c-0.194-0.847-0.528-1.638-0.976-2.352l1.519-1.519 c0.207-0.207,0.207-0.543,0-0.75l-1.688-1.688c-0.207-0.207-0.543-0.207-0.75,0l-1.519,1.519 c-0.714-0.448-1.506-0.782-2.352-0.976v-2.146c0-0.293-0.238-0.53-0.53-0.53h-2.387c-0.293,0-0.53,0.237-0.53,0.53v2.146 c-0.847,0.194-1.638,0.528-2.352,0.976l-1.519-1.519c-0.207-0.207-0.543-0.207-0.75,0l-1.688,1.688 c-0.207,0.207-0.207,0.543,0,0.75l1.519,1.519c-0.448,0.714-0.782,1.506-0.976,2.352h-2.146c-0.293,0-0.531,0.238-0.531,0.53 v2.387c0,0.293,0.238,0.53,0.531,0.53h2.146c0.194,0.847,0.528,1.638,0.976,2.352l-1.519,1.519c-0.207,0.207-0.207,0.543,0,0.75 l1.688,1.688c0.207,0.207,0.543,0.207,0.75,0l1.519-1.519c0.714,0.448,1.505,0.782,2.352,0.976v2.146 c0,0.293,0.237,0.53,0.53,0.53h2.387c0.293,0,0.53-0.237,0.53-0.53v-2.146c0.847-0.194,1.638-0.528,2.352-0.976l1.519,1.519 c0.207,0.207,0.543,0.207,0.75,0l1.688-1.688c0.207-0.207,0.207-0.543,0-0.75l-1.519-1.519c0.448-0.714,0.782-1.505,0.976-2.352 h2.146c0.293,0,0.53-0.237,0.53-0.53v-2.387C650.753,228.398,650.516,228.16,650.222,228.16z M640.586,233.178 c-1.819,0-3.293-1.475-3.293-3.293c0-1.819,1.474-3.293,3.293-3.293s3.293,1.475,3.293,3.293 C643.88,231.703,642.405,233.178,640.586,233.178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5470D3"
    },
    d: "M640.586,225.3c-2.532,0-4.584,2.053-4.584,4.585c0,2.532,2.053,4.584,4.584,4.584 c2.532,0,4.585-2.052,4.585-4.584C645.171,227.352,643.118,225.3,640.586,225.3z M640.586,232.684 c-1.546,0-2.799-1.253-2.799-2.799c0-1.546,1.253-2.799,2.799-2.799c1.546,0,2.799,1.253,2.799,2.799 C643.386,231.43,642.133,232.684,640.586,232.684z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9278 -0.3731 0.3731 0.9278 -5.9536 168.4005)",
    style: {
      fill: "#E67471"
    },
    cx: 432.064,
    cy: 99.581,
    rx: 41.783,
    ry: 41.783
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M411.328,121.053H452.8c1.825,0,3.304-1.479,3.304-3.304V83.246c0-1.825-1.479-3.304-3.304-3.304 h-41.472c-1.824,0-3.303,1.479-3.303,3.304v34.504C408.025,119.574,409.504,121.053,411.328,121.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5470D3"
    },
    d: "M408.025,88.546h48.079v-5.3c0-1.825-1.479-3.304-3.304-3.304h-41.472 c-1.824,0-3.303,1.479-3.303,3.304V88.546z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M444.619,81.777L444.619,81.777c0.538,0,0.975-0.437,0.975-0.975v-1.719 c0-0.538-0.437-0.975-0.975-0.975l0,0c-0.538,0-0.975,0.437-0.975,0.975v1.719C443.644,81.34,444.08,81.777,444.619,81.777z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M447.406,81.777L447.406,81.777c0.539,0,0.975-0.437,0.975-0.975v-1.719 c0-0.538-0.436-0.975-0.975-0.975l0,0c-0.538,0-0.975,0.437-0.975,0.975v1.719C446.431,81.34,446.867,81.777,447.406,81.777z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.722,81.777L416.722,81.777c0.539,0,0.975-0.437,0.975-0.975v-1.719 c0-0.538-0.436-0.975-0.975-0.975l0,0c-0.538,0-0.975,0.437-0.975,0.975v1.719C415.747,81.34,416.184,81.777,416.722,81.777z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M419.509,81.777L419.509,81.777c0.538,0,0.975-0.437,0.975-0.975v-1.719 c0-0.538-0.436-0.975-0.975-0.975l0,0c-0.539,0-0.975,0.437-0.975,0.975v1.719C418.534,81.34,418.971,81.777,419.509,81.777z "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M435.098,97.826h2.58c0.438,0,0.793-0.355,0.793-0.793v-2.579c0-0.438-0.355-0.793-0.793-0.793 h-2.58c-0.438,0-0.793,0.355-0.793,0.793v2.579C434.305,97.472,434.66,97.826,435.098,97.826z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M425.187,97.826h2.58c0.438,0,0.793-0.355,0.793-0.793v-2.58c0-0.438-0.355-0.793-0.793-0.793 h-2.579c-0.438,0-0.793,0.355-0.793,0.793v2.58C424.395,97.472,424.749,97.826,425.187,97.826z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M415.277,97.826h2.58c0.438,0,0.793-0.355,0.793-0.793v-2.58c0-0.438-0.355-0.793-0.793-0.793 h-2.58c-0.438,0-0.793,0.355-0.793,0.793v2.58C414.484,97.472,414.839,97.826,415.277,97.826z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M445.009,106.361h2.58c0.438,0,0.793-0.355,0.793-0.793v-2.58c0-0.438-0.355-0.793-0.793-0.793 h-2.579c-0.438,0-0.793,0.355-0.793,0.793v2.579C444.216,106.006,444.571,106.361,445.009,106.361z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M435.098,106.361h2.58c0.438,0,0.793-0.355,0.793-0.793v-2.58c0-0.438-0.355-0.793-0.793-0.793 h-2.58c-0.438,0-0.793,0.355-0.793,0.793v2.579C434.305,106.006,434.66,106.361,435.098,106.361z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M425.187,106.361h2.579c0.438,0,0.793-0.355,0.793-0.793v-2.58 c0-0.438-0.355-0.793-0.793-0.793h-2.58c-0.438,0-0.793,0.355-0.793,0.793v2.58 C424.395,106.006,424.749,106.361,425.187,106.361z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M415.277,106.361h2.58c0.438,0,0.793-0.355,0.793-0.793v-2.58c0-0.438-0.355-0.793-0.793-0.793 h-2.58c-0.438,0-0.793,0.355-0.793,0.793v2.58C414.484,106.006,414.839,106.361,415.277,106.361z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M445.009,114.895h2.58c0.438,0,0.793-0.355,0.793-0.793v-2.58c0-0.438-0.355-0.793-0.793-0.793 h-2.579c-0.438,0-0.793,0.355-0.793,0.793v2.58C444.216,114.54,444.571,114.895,445.009,114.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M435.098,114.895h2.58c0.438,0,0.793-0.355,0.793-0.793v-2.58c0-0.438-0.355-0.793-0.793-0.793 h-2.58c-0.438,0-0.793,0.355-0.793,0.793v2.58C434.305,114.54,434.66,114.895,435.098,114.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBE9FF"
    },
    d: "M425.187,114.895h2.579c0.438,0,0.793-0.355,0.793-0.793v-2.58 c0-0.438-0.355-0.793-0.793-0.793h-2.579c-0.438,0-0.793,0.355-0.793,0.793v2.58 C424.395,114.54,424.749,114.895,425.187,114.895z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 75.9841 425.5487)",
    style: {
      fill: "#E67471"
    },
    cx: 551.675,
    cy: 121.053,
    rx: 41.783,
    ry: 41.783
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 75.9841 425.5487)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 551.675,
    cy: 121.053,
    rx: 28.618,
    ry: 28.618
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5470D3"
    },
    d: "M551.675,92.435c-15.805,0-28.618,12.813-28.618,28.618c0,15.805,12.813,28.618,28.618,28.618 c15.805,0,28.618-12.813,28.618-28.618C580.293,105.248,567.48,92.435,551.675,92.435z M554.074,145.436v-3.908 c0-0.727-0.589-1.316-1.316-1.316h-2.168c-0.727,0-1.316,0.589-1.316,1.316v3.908c-11.615-1.129-20.854-10.368-21.983-21.983 h3.908c0.727,0,1.316-0.589,1.316-1.316v-2.167c0-0.727-0.589-1.316-1.316-1.316h-3.908 c1.129-11.615,10.368-20.854,21.983-21.983v3.908c0,0.727,0.589,1.316,1.316,1.316h2.168c0.727,0,1.316-0.589,1.316-1.316v-3.908 c11.615,1.129,20.854,10.368,21.983,21.983h-3.908c-0.727,0-1.316,0.589-1.316,1.316v2.167c0,0.727,0.589,1.316,1.316,1.316 h3.908C574.928,135.068,565.689,144.307,554.074,145.436z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 537.7799 127.8743)",
    style: {
      fill: "#D1C8D9",
      fontFamily: "'BebasKai'",
      fontSize: "20.4596px"
    }
  }, "24/7"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookWithUs);
export default __webpack_public_path__ + "static/media/Book-With-Us.01d013855baf18ddcd6551255ac0a53c.svg";
export { ForwardRef as ReactComponent };